import { h, Component, Host } from '@stencil/core';

@Component({
  tag: 'pk-toast',
  styleUrl: './scss/pk-toast.scss',
  shadow: true,
})
export class PkToast {
  // Own Properties
  // ====================

  // Reference to host HTML element
  // ===================================

  // State() variables
  // Inlined decorator, alphabetical order
  // =======================================

  // Public Property API
  // ========================

  // Prop lifecycle events
  // =======================

  // Events section
  // Requires JSDocs for public API documentation
  // ==============================================

  // Component lifecycle events
  // Ordered by their natural call order
  // =====================================

  // Listeners
  // ==============

  // Public methods API
  // These methods are exposed on the host element.
  // Always use two lines.
  // Public Methods must be async.
  // Requires JSDocs for public API documentation.
  // ===============================================

  // Local methods
  // Internal business logic.
  // ==========================

  // render() function
  // Always the last one in the class.
  // ===================================

  render() {
    return (
      <Host class="pk-toast">
        <slot />
      </Host>
    );
  }
}
